var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'webmail'
        });
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.webmail')))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("delete")])], 1)], 1), _c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-3",
    attrs: {
      "primary-title": "",
      "color": "blue-grey darken-2"
    }
  }, [_c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.messageDetail.subject))])]), _c('v-list', {
    attrs: {
      "three-line": "",
      "color": "grey lighten-3"
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', {
    attrs: {
      "color": "indigo"
    }
  }, [_c('span', {
    staticClass: "white--text title"
  }, [_vm._v(_vm._s(_vm.messageDetail.from.emailAddress.name.split(' ').map(function (i) {
    return i.charAt(0);
  }).join('')))])]), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.messageDetail.from.emailAddress.name))]), _c('v-list-tile-sub-title', {
    staticClass: "content body-1"
  }, [_vm._v("To:\n              " + _vm._s(_vm.messageDetail.toRecipients[0].emailAddress.name))]), _c('v-list-tile-sub-title', {
    staticClass: "content caption"
  }, [_vm._v(_vm._s(_vm.messageDetail.sentDateTime))])], 1), _c('v-list-tile-action', {
    staticClass: "action"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-1"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.sheet = true;
      }
    }
  }, [_vm._v("\n              more_horiz\n            ")])], 1)], 1), _c('v-divider')], 1), _vm.messageDetail.hasAttachments ? _c('v-card', [_vm.attachmentsLoading ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true,
      "height": "24"
    }
  }, [_vm._v("Loading attachments...")]) : _vm._e(), _vm._l(_vm.messageAttachments, function (attachment) {
    return [_vm.messageDetail.hasAttachments && attachment.isInline == false ? _c('v-btn', {
      key: attachment,
      staticClass: "attachment",
      attrs: {
        "color": "blue",
        "dark": "",
        "flat": "",
        "left": "",
        "href": 'data:' + attachment.contenttype + ';base64,' + attachment.contentBytes,
        "download": attachment.name
      }
    }, [_c('v-icon', [_vm._v("book")]), _vm._v("\n            " + _vm._s(attachment.name) + "\n          ")], 1) : _vm._e()];
  })], 2) : _vm._e(), _c('v-card-text', {
    staticStyle: {
      "max-width": "100vw",
      "overflow": "hidden"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  })], 1)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "white",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.closeReplyDialog();
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _c('v-toolbar-title', [_vm._v("Reply")]), _c('v-spacer'), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.sendMessage();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("\n              send\n            ")])], 1)], 1)], 1), _c('v-divider'), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-1",
    attrs: {
      "light": "",
      "prefix": "To:",
      "value": "messageDetail.from.emailAddress.address",
      "readonly": ""
    },
    model: {
      value: _vm.to,
      callback: function callback($$v) {
        _vm.to = $$v;
      },
      expression: "to"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.contacts,
      "loading": _vm.isLoading,
      "search-input": _vm.search,
      "item-text": "scoredEmailAddresses[0].address",
      "item-value": "scoredEmailAddresses[0].address",
      "color": "white",
      "label": "CC",
      "return-object": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "deletable-chips": "",
      "small-chips": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    model: {
      value: _vm.cc,
      callback: function callback($$v) {
        _vm.cc = $$v;
      },
      expression: "cc"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "no-border pa-1",
    attrs: {
      "prefix": "Subject:",
      "value": 'Re:' + _vm.messageDetail.subject
    },
    model: {
      value: _vm.subject,
      callback: function callback($$v) {
        _vm.subject = $$v;
      },
      expression: "subject"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "message",
      "label": "Message",
      "auto-grow": ""
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  })], 1), _c('attachments')], 1)], 1), _c('v-bottom-sheet', {
    model: {
      value: _vm.sheet,
      callback: function callback($$v) {
        _vm.sheet = $$v;
      },
      expression: "sheet"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    on: {
      "click": function click($event) {
        return _vm.openReplyDialog();
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("\n            reply\n          ")])], 1), _c('v-list-tile-title', [_vm._v("Reply")])], 1), _c('v-list-tile', {
    on: {
      "click": function click($event) {
        return _vm.deleteMessage();
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            delete\n          ")])], 1), _c('v-list-tile-title', {
    staticClass: "red--text"
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }